import React from 'react'
import PropTypes from 'prop-types'

const menuStyles = {
  position: 'absolute',
  top: '100%',
  right: '0',
  zIndex: '999',
  minWidth: '160px',
  padding: '5px 0',
  background: '#fff',
  border: '1px solid rgba(0,0,0,.15)',
  borderRadius: '4px',
  boxShadow: '0 0 12px rgba(0,0,0,.175)',
  listStyle: 'none',
}

const Menu = ({ children, style }) => {
  const combinedStyles = style ? { ...menuStyles, ...style } : menuStyles
  return <div style={combinedStyles}>{children}</div>
}

Menu.displayName = 'Menu'

Menu.propTypes = {
  children: PropTypes.node,
  style: PropTypes.objectOf(PropTypes.string),
}
Menu.defaultProps = {
  children: undefined,
  style: undefined,
}

Menu.defaultProps = {
  children: null,
}

export default Menu
